import { useEffect,useState } from "react";
// import "../../../../../assets/css/calendar.css";
import { Spin } from "antd"; // Ant Design loading spinner
import { getLeaveCalenderApi,getLeaveTeamApi } from "api/services/leave";
import FilterSelect from "components/Form/filterSelect";
import CalendarModal from "components/modelpopup/CalendarModal";
import { useSelector } from 'react-redux';
import { formatDateHandler2 } from "utils/common";

const Calendar = () => {
  const [weekendsVisible] = useState(true);
  const [calendarData, setCalendarData] = useState([]);
  const [calendarLoading, setCalendarLoading] = useState(false);
  const [calendarYear, setCalendarYear] = useState(new Date().getFullYear()); // For Year View
  const [teamViewYear, setTeamViewYear] = useState(new Date().getFullYear()); // For Team View
  const [monthList] = useState([
    { value: 1, label: "January" },
    { value: 2, label: "February" },
    { value: 3, label: "March" },
    { value: 4, label: "April" },
    { value: 5, label: "May" },
    { value: 6, label: "June" },
    { value: 7, label: "July" },
    { value: 8, label: "August" },
    { value: 9, label: "September" },
    { value: 10, label: "October" },
    { value: 11, label: "November" },
    { value: 12, label: "December" }
  ]);
  const [calendarMonth, setCalendarMonth] = useState(monthList[new Date().getMonth()]);

  const [leaveType, setLeaveType] = useState([]);
  const [leaveColor, setLeaveColor] = useState({});
  const [defaultEvents, setDefaultEvents] = useState([]);
  const [teamData, setTeamData] = useState([]);

  const [leaveTypeTeam, setLeaveTypeTeam] = useState([]);
  const [leaveColorTeam, setLeaveColorTeam] = useState({});

  // Get current year
  const currentYear = new Date().getFullYear();
  
  // Generate year list from 2025 to current year + 4
  const [yearList] = useState(() => {
    const startYear = 2025;
    const endYear = currentYear + 3;
    const years = [];
    for (let year = startYear; year <= endYear; year++) {
      years.push(year.toString());
    }
    return years;
  });

  const { userData, department, costCenter } = useSelector((state) => state.common);
  // Separate states for year view and team view user selection
  const [selectedUser, setSelectedUser] = useState(null); // For year view (single select)
  const [selectedTeamUsers, setSelectedTeamUsers] = useState([]); // For team view (multi select)
  
  // New state for department and cost center filters
  const [selectedDepartment, setSelectedDepartment] = useState(null); // For year view
  const [selectedCostCenter, setSelectedCostCenter] = useState(null); // For year view
  const [selectedTeamDepartment, setSelectedTeamDepartment] = useState(null); // For team view
  const [selectedTeamCostCenter, setSelectedTeamCostCenter] = useState(null); // For team view
  
  // Filtered user lists based on department/cost center selection
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [filteredTeamUsers, setFilteredTeamUsers] = useState([]);

  // Format options for dropdowns
  const departmentOptions = department?.map(dept => ({
    value: dept.id,
    label: dept.name
  })) || [];
  
  const costCenterOptions = costCenter?.map(cc => ({
    value: cc.id,
    label: cc.code
  })) || [];

  // Filter users based on department and cost center selections
  useEffect(() => {
    let filtered = [...userData || []];
    console.log(filtered,filtered.length, selectedDepartment, selectedCostCenter);
    
    if (selectedDepartment) {
      filtered = filtered.filter(user => 
        user.employment?.department === selectedDepartment.value
      );
    }
    
    if (selectedCostCenter) {
      filtered = filtered.filter(user => 
        user.cost_center === selectedCostCenter.value
      );
    }
    
    console.log(filtered.length);

    setFilteredUsers(filtered.map(user => ({
      value: user.id,
      label: `${user.first_name} ${user.last_name}`
    })));
    
    // Reset selected user if not in filtered list
    if (selectedUser && !filtered.some(user => user.id === selectedUser.value)) {
      setSelectedUser(null);
    }
  }, [userData, selectedDepartment, selectedCostCenter]);
  
  // Filter team users based on department and cost center selections
  useEffect(() => {
    let filtered = [...userData || []];
    
    if (selectedTeamDepartment) {
      filtered = filtered.filter(user => 
        user.employment?.department === selectedTeamDepartment.value
      );
    }
    
    if (selectedTeamCostCenter) {
      filtered = filtered.filter(user => 
        user.cost_center === selectedTeamCostCenter.value
      );
    }
    
    setFilteredTeamUsers(filtered.map(user => ({
      value: user.id,
      label: `${user.first_name} ${user.last_name}`
    })));
    
    // Filter selected team users to only include those in the filtered list
    if (selectedTeamUsers.length > 0) {
      const validUserIds = filtered.map(user => user.id);
      const newSelectedUsers = selectedTeamUsers.filter(user => 
        validUserIds.includes(user.value)
      );
      
      if (newSelectedUsers.length !== selectedTeamUsers.length) {
        setSelectedTeamUsers(newSelectedUsers);
      }
    }
  }, [userData, selectedTeamDepartment, selectedTeamCostCenter]);

  useEffect(() => {
    setCalendarLoading(true);
    getLeaveCalenderApi({ 
      year: calendarYear,
      company_user: selectedUser?.value || '', // Single user ID
      department: selectedDepartment?.value || '',
      cost_center: selectedCostCenter?.value || ''
    })
      .then((response) => {
        setCalendarYear(response.data.year);
        setLeaveType(response.data.leave_type);
        setLeaveColor(response.data.colors);
        setDefaultEvents(response.data.leave_days);
        setCalendarLoading(false);
      })
      .catch((err) => {
        setCalendarLoading(false);
      });
  }, [calendarYear, selectedUser, selectedDepartment, selectedCostCenter]);

  useEffect(() => {
    setCalendarLoading(true);
    getLeaveTeamApi({ 
      year: teamViewYear, 
      month: calendarMonth.value,
      company_user: selectedTeamUsers.map(user => user.value).join(','),
      department: selectedTeamDepartment?.value || '',
      cost_center: selectedTeamCostCenter?.value || ''
    })
      .then((response) => {
        setLeaveTypeTeam(response.data.leave_type);
        setLeaveColorTeam(response.data.colors);
        setTeamData(response.data.data);
        setCalendarLoading(false);
      })
      .catch((err) => {
        setCalendarLoading(false);
      });
  }, [teamViewYear, calendarMonth, selectedTeamUsers, selectedTeamDepartment, selectedTeamCostCenter]);

  //   const defaultEvents = [
  //     {
  //       title: "AL",
  //       start: Date.now() + 148000000,
  //       className: "bg-purple",
  //     },
  //     {
  //       title: "SL",
  //       start: Date.now(),
  //       end: Date.now(),
  //       className: "bg-success",
  //     },

  //     {
  //       title: "AL",
  //       start: Date.now() + 338000000,
  //       className: "bg-primary",
  //     },
  //   ];

  // Generate month labels and FullCalendar components for each month
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // Helper function to generate the days for a given month
  const generateMonthDays = (monthIndex) => {
    const date = new Date(calendarYear, monthIndex, 1); // Start of the month
    const daysInMonth = new Date(calendarYear, monthIndex + 1, 0).getDate(); // Last day of the month

    const days = [];
    for (let day = 1; day <= daysInMonth; day++) {
      days.push(day); // Push each day of the month
    }

    return days;
  };

  // Helper function to get events for a specific month
  const getMonthEvents = (monthIndex) => {
    return defaultEvents.filter((event) => {
      const eventMonth = new Date(event.start).getMonth();
      return eventMonth === monthIndex;
    });
  };
  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        {/* Page Header */}
        <div className="page-header mb-4">
          <div className="row align-items-center">
            <div className="col">
              <h3 className="page-title" style={{ fontSize: "24px", fontWeight: "600", color: "#1f2937" }}>Leave View</h3>
            </div>
          </div>
        </div>
        {/* /Page Header */}
        <div className="row">
          <div className="col-lg-12 year-view-section">
            <div className="card shadow-sm mb-4" style={{ borderRadius: "12px", border: "1px solid #e0e0e0", background: "linear-gradient(to bottom, #ffffff 0%, #fef2f2 100%)" }}>
              <div className="card-body p-4">
                <div className="row">
                  <div className="col-md-12">
                    {/* Calendar */}
                    <div id="calendar" />

                    <div className="w-100 mb-3">
                      <div className="d-flex align-items-center mb-3" style={{ flexShrink: 0 }}>
                        <div style={{
                          width: "36px",
                          height: "36px",
                          borderRadius: "8px",
                          background: "linear-gradient(135deg, rgb(211, 0, 26) 0%, #f43b48 50%, #fc133d 100%)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginRight: "12px",
                          boxShadow: "0 2px 8px rgba(211, 0, 26, 0.2)",
                          flexShrink: 0
                        }}>
                          <i className="las la-calendar-alt" style={{ fontSize: "18px", color: "#fff" }}></i>
                        </div>
                        <h4 style={{ fontSize: "18px", fontWeight: "600", color: "#333", margin: 0, whiteSpace: "nowrap" }}>Year View</h4>
                      </div>
                      <div className="d-flex gap-2 flex-wrap" style={{ width: "100%", maxWidth: "100%" }}>
                        <div style={{ width: "150px", flexShrink: 0 }}>
                          <FilterSelect
                            className={"me-2"}
                            optionLabel={"label"}
                            optionValue="value"
                            placeholder={"Select year"}
                            value={(() => {
                              const yearOptions = yearList.map((item) => ({ value: item, label: item }));
                              return yearOptions.find(opt => opt.value === calendarYear.toString()) || null;
                            })()}
                            options={yearList.map((item) => {
                              return { value: item, label: item };
                            })}
                            onChange={(e) => setCalendarYear(e ? parseInt(e.value) : new Date().getFullYear())}
                          />
                        </div>
                        <div style={{ width: "150px", flexShrink: 0 }}>
                          <FilterSelect
                            className={"me-2"}
                            optionLabel={"label"}
                            optionValue="value"
                            placeholder={"Select department"}
                            value={selectedDepartment ? departmentOptions.find(opt => opt.value === selectedDepartment.value) : null}
                            options={departmentOptions}
                            onChange={(e) => setSelectedDepartment(e)}
                            isMulti={false}
                            isClearable={true}
                          />
                        </div>
                        <div style={{ width: "150px", flexShrink: 0 }}>
                          <FilterSelect
                            className={"me-2"}
                            optionLabel={"label"}
                            optionValue="value"
                            placeholder={"Select cost center"}
                            value={selectedCostCenter ? costCenterOptions.find(opt => opt.value === selectedCostCenter.value) : null}
                            options={costCenterOptions}
                            onChange={(e) => setSelectedCostCenter(e)}
                            isMulti={false}
                            isClearable={true}
                          />
                        </div>
                        <div style={{ width: "150px", flexShrink: 0 }}>
                          <FilterSelect
                            className={"me-2"}
                            optionLabel={"label"}
                            optionValue="value"
                            placeholder={"Select employee"}
                            value={(() => {
                              const userOptions = filteredUsers.length > 0 ? filteredUsers : userData?.map(user => ({
                                value: user.id,
                                label: `${user.first_name} ${user.last_name}`
                              })) || [];
                              if (selectedUser && selectedUser.value) {
                                return userOptions.find(opt => opt.value === selectedUser.value) || null;
                              }
                              return null;
                            })()}
                            options={filteredUsers.length > 0 ? filteredUsers : userData?.map(user => ({
                              value: user.id,
                              label: `${user.first_name} ${user.last_name}`
                            })) || []}
                            onChange={(e) => setSelectedUser(e)}
                            isMulti={false} // Single select for year view
                            isClearable={true}
                          />
                        </div>
                      </div>
                    </div>
                    {/* Show loading spinner when loading */}
                    {calendarLoading && (
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "rgba(255, 255, 255, 0.8)",
                          zIndex: 10,
                        }}
                      >
                        <Spin size="large" />
                      </div>
                    )}

                    <div className="card shadow-sm mb-4" style={{ borderRadius: "12px", border: "1px solid #e0e0e0", overflow: "hidden" }}>
                      <div style={{ overflowX: "auto", overflowY: "visible" }}>
                        <table
                          className="year-view-calendar"
                          style={{ width: "100%", borderCollapse: "collapse", tableLayout: "fixed" }}
                        >
                          <thead>
                            <tr>
                              <td
                                style={{
                                  textAlign: "center",
                                  border: "1px solid #e0e0e0",
                                  fontSize: 13,
                                  fontWeight: "600",
                                  backgroundColor: "#f8f9fa",
                                  padding: "10px 8px",
                                  color: "#333",
                                  width: "80px", // 👈 UPDATE MONTH COLUMN WIDTH HERE (Line ~383)
                                  minWidth: "80px" // 👈 UPDATE MONTH COLUMN MIN WIDTH HERE (Line ~384)
                                }}
                              >
                                Month
                              </td>
                              {Array.from({ length: 31 }, (_, i) => (
                                <td
                                  key={i}
                                  style={{
                                    textAlign: "center",
                                    border: "1px solid #e0e0e0",
                                    backgroundColor: "#f8f9fa",
                                    fontSize: 11,
                                    fontWeight: "600",
                                    padding: "6px 2px",
                                    color: "#6b7280",
                                    width: "18px", // 👈 UPDATE CELL WIDTH HERE (Line ~402)
                                    minWidth: "18px", // 👈 UPDATE MIN WIDTH HERE (Line ~403)
                                    maxWidth: "18px" // 👈 UPDATE MAX WIDTH HERE (Line ~404)
                                  }}
                                >
                                  {i + 1}
                                </td>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {/* Render each month as a row */}
                            {months.map((month, monthIndex) => (
                              <tr key={monthIndex}>
                                <td
                                  style={{
                                    textAlign: "center",
                                    backgroundColor: "#f8f9fa",
                                    border: "1px solid #e0e0e0",
                                    fontSize: 13,
                                    fontWeight: "600",
                                    padding: "10px 8px",
                                    color: "#333",
                                    width: "80px", // 👈 UPDATE MONTH COLUMN WIDTH HERE (Line ~420)
                                    minWidth: "80px" // 👈 UPDATE MONTH COLUMN MIN WIDTH HERE (Line ~421)
                                  }}
                                >
                                  {month}
                                </td>

                                {/* Render days for each month */}
                                {Array.from({ length: 31 }, (_, dayIndex) => {
                                  const days = generateMonthDays(monthIndex);
                                  const currentDay = days[dayIndex];

                                  return (
                                    <td
                                      key={dayIndex}
                                      style={{
                                        border: "1px solid #e0e0e0",
                                        width: "18px", // 👈 UPDATE CELL WIDTH HERE (Line ~441)
                                        height: "18px", // 👈 UPDATE CELL HEIGHT HERE (Line ~442)
                                        textAlign: "center",
                                        verticalAlign: "middle",
                                        backgroundColor: "#ffffff",
                                        padding: "2px", // 👈 UPDATE CELL PADDING HERE (Line ~446)
                                        position: "relative",
                                        minWidth: "18px", // 👈 UPDATE MIN WIDTH HERE (Line ~448)
                                        maxWidth: "18px", // 👈 UPDATE MAX WIDTH HERE (Line ~449)
                                        boxSizing: "border-box" // Ensures padding is included in width/height
                                      }}
                                    >
                                      {currentDay ? (
                                        <>
                                          {/* Render events for that day */}
                                          {getMonthEvents(monthIndex)
                                            .filter(
                                              (event) =>
                                                new Date(
                                                  event.start
                                                ).getDate() === currentDay
                                            ).slice(0,1)
                                            .map((event, eventIndex) => (
                                              <div
                                              className="w-100 h-100 d-flex justify-content-center align-items-center"
                                              data-toggle="tooltip"
                                               data-placement="top" 
                                              data-html="true"
                                              title={`${event.code}  (${ formatDateHandler2(event.start_date) } - ${formatDateHandler2(event.end_date)})`}
                                                key={eventIndex}
                                                style={{
                                                  backgroundColor: event.eventBackgroundColor,
                                                  color: event.eventTextColor,
                                                  fontSize: "9px",
                                                  fontWeight: "600",
                                                  borderRadius: "2px",
                                                  width: "100%",
                                                  height: "100%",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                  textAlign: "center",
                                                  padding: "1px",
                                                  overflow: "hidden",
                                                  whiteSpace: "nowrap",
                                                  textOverflow: "ellipsis"
                                                }}
                                              >
                                                {(event.short_code || event.code || "").substring(0, 2)}
                                              </div>
                                            ))}
                                        </>
                                      ) : (
                                        <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>&nbsp;</div>
                                      )}
                                    </td>
                                  );
                                })}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div className="card shadow-sm mb-4" style={{ borderRadius: "12px", border: "1px solid #e0e0e0", background: "linear-gradient(to bottom, #ffffff 0%, #fef2f2 100%)" }}>
                      <div className="card-body p-4">
                        <div className="row g-4">
                          <div className="col-md-6">
                            <h6 style={{ fontSize: "13px", fontWeight: "600", color: "#333", marginBottom: "12px", textTransform: "uppercase", letterSpacing: "0.5px" }}>Leave Types</h6>
                            <div className="d-flex flex-wrap gap-2">
                              {leaveType.map((leave, index) => (
                                <span
                                  key={index}
                                  style={{ 
                                    fontSize: "12px",
                                    fontWeight: "500",
                                    color: "#333",
                                    padding: "4px 12px",
                                    background: "#ffffff",
                                    borderRadius: "6px",
                                    border: "1px solid #e0e0e0",
                                    display: "inline-block"
                                  }}
                                >
                                  <strong style={{ color: "#D3001A" }}>{leave.short_code}</strong> - {leave.description}
                                </span>
                              ))}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <h6 style={{ fontSize: "13px", fontWeight: "600", color: "#333", marginBottom: "12px", textTransform: "uppercase", letterSpacing: "0.5px" }}>Status Colors</h6>
                            <div className="d-flex flex-wrap gap-2">
                              {Object.entries(leaveColor).map(
                                ([status, color], index) => (
                                  <div
                                    key={index}
                                    className="d-flex align-items-center"
                                    style={{ 
                                      padding: "4px 12px",
                                      background: "#ffffff",
                                      borderRadius: "6px",
                                      border: "1px solid #e0e0e0"
                                    }}
                                  >
                                    <div
                                      style={{
                                        height: "16px",
                                        width: "16px",
                                        backgroundColor: color,
                                        borderRadius: "4px",
                                        marginRight: "8px",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.15)",
                                        flexShrink: 0
                                      }}
                                    />
                                    <span style={{ fontSize: "12px", fontWeight: "500", color: "#333" }}>
                                      {status}
                                    </span>
                                  </div>
                                )
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="w-100 mb-3 mt-4 team-view-section">
                      <div className="d-flex align-items-center mb-3" style={{ flexShrink: 0 }}>
                        <div style={{
                          width: "36px",
                          height: "36px",
                          borderRadius: "8px",
                          background: "linear-gradient(135deg, rgb(211, 0, 26) 0%, #f43b48 50%, #fc133d 100%)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginRight: "12px",
                          boxShadow: "0 2px 8px rgba(211, 0, 26, 0.2)",
                          flexShrink: 0
                        }}>
                          <i className="las la-users" style={{ fontSize: "18px", color: "#fff" }}></i>
                        </div>
                        <h4 style={{ fontSize: "18px", fontWeight: "600", color: "#333", margin: 0, whiteSpace: "nowrap" }}>Team View</h4>
                      </div>
                      <div className="d-flex gap-2 flex-wrap" style={{ width: "100%", maxWidth: "100%" }}>
                        <div style={{ width: "150px", flexShrink: 0 }}>
                          <FilterSelect
                            className={"me-2"}
                            optionLabel={"label"}
                            optionValue="value"
                            placeholder={"Select year"}
                            value={(() => {
                              const yearOptions = yearList.map((item) => ({ value: item.toString(), label: item.toString() }));
                              return yearOptions.find(opt => parseInt(opt.value) === teamViewYear) || null;
                            })()}
                            options={yearList.map((item) => {
                              return { value: item.toString(), label: item.toString() };
                            })}
                            onChange={(e) => setTeamViewYear(e ? parseInt(e.value) : new Date().getFullYear())}
                          />
                        </div>
                        <div style={{ width: "150px", flexShrink: 0 }}>
                          <FilterSelect
                            className={"me-2"}
                            optionLabel={"label"}
                            optionValue="value"
                            placeholder={"Select month"}
                            value={calendarMonth ? monthList.find(opt => opt.value === calendarMonth.value) : null}
                            options={monthList}
                            onChange={(e) => setCalendarMonth(e)}
                          />
                        </div>
                        <div style={{ width: "150px", flexShrink: 0 }}>
                          <FilterSelect
                            className={"me-2"}
                            optionLabel={"label"}
                            optionValue="value"
                            placeholder={"Select department"}
                            value={selectedTeamDepartment ? departmentOptions.find(opt => opt.value === selectedTeamDepartment.value) : null}
                            options={departmentOptions}
                            onChange={(e) => setSelectedTeamDepartment(e)}
                            isMulti={false}
                          />
                        </div>
                        <div style={{ width: "150px", flexShrink: 0 }}>
                          <FilterSelect
                            className={"me-2"}
                            optionLabel={"label"}
                            optionValue="value"
                            placeholder={"Select cost center"}
                            value={selectedTeamCostCenter ? costCenterOptions.find(opt => opt.value === selectedTeamCostCenter.value) : null}
                            options={costCenterOptions}
                            onChange={(e) => setSelectedTeamCostCenter(e)}
                            isMulti={false}
                          />
                        </div>
                        <div style={{ width: "150px", flexShrink: 0 }}>
                          <FilterSelect
                            className={"me-2"}
                            optionLabel={"label"}
                            optionValue="value"
                            placeholder={"Select employees"}
                            value={(() => {
                              const teamUserOptions = filteredTeamUsers.length > 0 ? filteredTeamUsers : userData?.map(user => ({
                                value: user.id,
                                label: `${user.first_name} ${user.last_name}`
                              })) || [];
                              if (selectedTeamUsers && selectedTeamUsers.length > 0) {
                                return selectedTeamUsers.map(selected => 
                                  teamUserOptions.find(opt => opt.value === selected.value)
                                ).filter(Boolean);
                              }
                              return [];
                            })()}
                            options={filteredTeamUsers.length > 0 ? filteredTeamUsers : userData?.map(user => ({
                              value: user.id,
                              label: `${user.first_name} ${user.last_name}`
                            })) || []}
                            onChange={(e) => setSelectedTeamUsers(e || [])}
                            isMulti={true} // Multi select for team view
                          />
                        </div>
                      </div>
                    </div>

                    <div className="card shadow-sm mb-4" style={{ borderRadius: "12px", border: "1px solid #e0e0e0", overflow: "hidden" }}>
                      <div style={{ overflowX: "auto", overflowY: "visible" }}>
                        <table className="table table-bordered mb-0" style={{ margin: 0, tableLayout: "fixed", width: "100%" }}>
                          <thead>
                            <tr>
                              <td rowSpan={2} style={{ 
                                fontSize: 12, 
                                fontWeight: "600",
                                backgroundColor: "#f8f9fa",
                                border: "1px solid #e0e0e0",
                                padding: "6px 4px",
                                color: "#333",
                                width: "35px", // 👈 UPDATE EMPLOYEE CODE COLUMN WIDTH HERE (Line ~680)
                                minWidth: "35px",
                                maxWidth: "35px"
                              }}>
                                Code
                              </td>
                              <td rowSpan={2} style={{ 
                                fontSize: 12, 
                                fontWeight: "600",
                                backgroundColor: "#f8f9fa",
                                border: "1px solid #e0e0e0",
                                padding: "6px 4px",
                                color: "#333",
                                width: "100px", // 👈 UPDATE EMPLOYEE NAME COLUMN WIDTH HERE (Line ~692)
                                minWidth: "100px",
                                maxWidth: "100px"
                              }}>
                                Name
                              </td>
                              <td rowSpan={2} style={{ 
                                fontSize: 12, 
                                fontWeight: "600",
                                backgroundColor: "#f8f9fa",
                                border: "1px solid #e0e0e0",
                                padding: "6px 4px",
                                color: "#333",
                                width: "90px", // 👈 UPDATE POSITION COLUMN WIDTH HERE (Line ~704)
                                minWidth: "90px",
                                maxWidth: "90px"
                              }}>
                                Position
                              </td>
                              <td
                                colSpan={31}
                                style={{ 
                                  fontSize: 13,
                                  fontWeight: "600",
                                  backgroundColor: "#f8f9fa",
                                  border: "1px solid #e0e0e0",
                                  padding: "10px 8px",
                                  color: "#333",
                                  width: "558px", // 18px * 31 days
                                  minWidth: "558px",
                                  maxWidth: "558px"
                                }}
                                align="center"
                              >
                                {calendarMonth.label} {teamViewYear}
                              </td>
                            </tr>
                            <tr>
                              {/* Create headers for each day of the month */}
                              {[...Array(31)].map((_, index) => (
                                <td
                                  style={{ 
                                    fontSize: 11,
                                    fontWeight: "600",
                                    backgroundColor: "#f8f9fa",
                                    border: "1px solid #e0e0e0",
                                    padding: "6px 2px",
                                    color: "#6b7280",
                                    width: "18px", // 👈 UPDATE TEAM VIEW CELL WIDTH HERE (Line ~738)
                                    minWidth: "18px", // 👈 UPDATE TEAM VIEW MIN WIDTH HERE (Line ~739)
                                    maxWidth: "18px" // 👈 UPDATE TEAM VIEW MAX WIDTH HERE (Line ~740)
                                  }}
                                  key={index + 1}
                                  className="text-center"
                                >
                                  {index + 1}
                                </td>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {teamData.map((employee) => (
                              <tr key={employee.company_user.id} style={{ backgroundColor: "#ffffff" }}>
                                {/* Employee details */}
                                <td style={{ 
                                  fontSize: 11,
                                  border: "1px solid #e0e0e0",
                                  padding: "4px",
                                  width: "35px", // 👈 UPDATE EMPLOYEE CODE COLUMN WIDTH HERE (Line ~758)
                                  minWidth: "35px",
                                  maxWidth: "35px",
                                  textAlign: "center",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap"
                                }}>
                                  {employee.company_user.emp_no}
                                </td>
                                <td style={{ 
                                  fontSize: 11,
                                  border: "1px solid #e0e0e0",
                                  padding: "4px",
                                  width: "100px", // 👈 UPDATE EMPLOYEE NAME COLUMN WIDTH HERE (Line ~767)
                                  minWidth: "100px",
                                  maxWidth: "100px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap"
                                }}>
                                  {employee.company_user.first_name}{" "}
                                  {employee.company_user.last_name}
                                </td>
                                <td style={{ 
                                  fontSize: 11,
                                  border: "1px solid #e0e0e0",
                                  padding: "4px",
                                  width: "90px", // 👈 UPDATE POSITION COLUMN WIDTH HERE (Line ~779)
                                  minWidth: "90px",
                                  maxWidth: "90px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap"
                                }}>
                                  {employee.company_user.position_name}
                                </td>
                                {/* Loop through each day of the month and display leave status */}
                                {[...Array(31)].map((_, day) => {
                                  const leaveStatus =
                                    employee.leave_days[day + 1];
                                  return (
                                    <td
                                      key={day + 1}
                                      style={{
                                        border: "1px solid #e0e0e0",
                                        width: "18px", // 👈 UPDATE TEAM VIEW CELL WIDTH HERE (Line ~804)
                                        height: "18px", // 👈 UPDATE TEAM VIEW CELL HEIGHT HERE (Line ~805)
                                        backgroundColor: leaveStatus?.eventBackgroundColor || "#ffffff",
                                        padding: "2px", // 👈 UPDATE TEAM VIEW CELL PADDING HERE (Line ~807)
                                        textAlign: "center",
                                        verticalAlign: "middle",
                                        position: "relative",
                                        minWidth: "18px", // 👈 UPDATE TEAM VIEW MIN WIDTH HERE (Line ~811)
                                        maxWidth: "18px", // 👈 UPDATE TEAM VIEW MAX WIDTH HERE (Line ~812)
                                        boxSizing: "border-box" // Ensures padding is included in width/height
                                      }}
                                    >
                                     <div
                                     className="w-100 h-100 d-flex justify-content-center align-items-center"
                                             key={day + 1}
                                              style={{
                                                backgroundColor: leaveStatus?.eventBackgroundColor || "transparent",
                                                color: leaveStatus?.eventTextColor || "#333",
                                                fontSize: "9px",
                                                fontWeight: "600",
                                                borderRadius: "2px",
                                                width: "100%",
                                                height: "100%",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                textAlign: "center",
                                                padding: "1px",
                                                overflow: "hidden",
                                                whiteSpace: "nowrap",
                                                textOverflow: "ellipsis"
                                              }}
                                            >
                                              {(leaveStatus?.short_code || "").substring(0, 2)}
                                            </div>
                                    </td>
                                  );
                                })}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div className="card shadow-sm mb-4" style={{ borderRadius: "12px", border: "1px solid #e0e0e0", background: "linear-gradient(to bottom, #ffffff 0%, #fef2f2 100%)" }}>
                      <div className="card-body p-4">
                        <div className="row g-4">
                          <div className="col-md-6">
                            <h6 style={{ fontSize: "13px", fontWeight: "600", color: "#333", marginBottom: "12px", textTransform: "uppercase", letterSpacing: "0.5px" }}>Leave Types</h6>
                            <div className="d-flex flex-wrap gap-2">
                              {leaveTypeTeam.map((leave, index) => (
                                <span
                                  key={index}
                                  style={{ 
                                    fontSize: "12px",
                                    fontWeight: "500",
                                    color: "#333",
                                    padding: "4px 12px",
                                    background: "#ffffff",
                                    borderRadius: "6px",
                                    border: "1px solid #e0e0e0",
                                    display: "inline-block"
                                  }}
                                >
                                  <strong style={{ color: "#D3001A" }}>{leave.short_code}</strong> - {leave.description}
                                </span>
                              ))}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <h6 style={{ fontSize: "13px", fontWeight: "600", color: "#333", marginBottom: "12px", textTransform: "uppercase", letterSpacing: "0.5px" }}>Status Colors</h6>
                            <div className="d-flex flex-wrap gap-2">
                              {Object.entries(leaveColorTeam).map(
                                ([status, color], index) => (
                                  <div
                                    key={index}
                                    className="d-flex align-items-center"
                                    style={{ 
                                      padding: "4px 12px",
                                      background: "#ffffff",
                                      borderRadius: "6px",
                                      border: "1px solid #e0e0e0"
                                    }}
                                  >
                                    <div
                                      style={{
                                        height: "16px",
                                        width: "16px",
                                        backgroundColor: color,
                                        borderRadius: "4px",
                                        marginRight: "8px",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.15)",
                                        flexShrink: 0
                                      }}
                                    />
                                    <span style={{ fontSize: "12px", fontWeight: "500", color: "#333" }}>
                                      {status}
                                    </span>
                                  </div>
                                )
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <style jsx>{`
          @media (min-width: 768px) {
            .year-view-section {
              margin-bottom: 3rem !important;
            }
            .team-view-section {
              margin-bottom: 3rem !important;
            }
          }
          @media (max-width: 767px) {
            .year-view-calendar thead td:not(:first-child),
            .year-view-calendar tbody td:not(:first-child) {
              width: 28px !important;
              min-width: 28px !important;
              max-width: 28px !important;
              height: 28px !important;
            }
          }
        `}</style>
      </div>

      <CalendarModal />
    </div>
  );
};

export default Calendar;
